(ns minorodata.components.analytics-models.core
  (:require [react :as react]
            [minorodata.app.handlers :refer [dispatch]]
            [minorodata.components.analytics-models.panel :refer [panel]]
            [minorodata.components.analytics-models.sidebar :refer [sidebar]]
            [minorodata.components.connections.drawers :as connections-drawers]
            [re-posh.core :as re-posh]
            [ui.page :refer [page-columns page-content page-root]]))


(defn instances-list' [{:keys [route]}]
  (react/useEffect
   (fn []
     (dispatch [:analytics-models.events/init])
     js/undefined)
   #js [])

  [:<>
   [page-root
    [page-content {:variant :border}
     [page-columns
      [sidebar]
      [panel]]]]
   [:f> connections-drawers/drawers]])

(defn instances-list []
  (let [route @(re-posh/subscribe [:app-route/pull])]
    [:f> instances-list' {:route route}]))
